<app-layout>
  <div class="card border-left">
    <h1 class="title">
      <i class="pi pi-graduation-cap" style="font-size: 2rem;"></i>
      Pestforce Academy
    </h1>

    <div class="course-container">
      <div class="course-card" *ngFor="let course of courses">
        <picture class="">
          <img [src]="course?.miniature ?? 'https://i.sstatic.net/y9DpT.jpg'" class="course-image" [alt]="course.title">
        </picture>

        <h5 class="course-title">
          {{ course.name }}
        </h5>

        <p class="course-description">
          {{ course.description }}
        </p>

        <div class="course-badge">
          <p-badge *ngIf="!course.cost" value="Curso gratuito" severity="info" />
          <p-badge *ngIf="course.cost" value="Curso de pago" severity="danger" />
        </div>

        <div class="tags-container">
          <p class="tag">
            <span class="tag-span">
              <i class="pi pi-clock" aria-hidden="true"></i>
              Duración:{{ ' ' }}
            </span>
            {{ course.duration }}
          </p>

          <p class="tag">
            <span class="tag-span">
              <i class="pi pi-money-bill" aria-hidden="true"></i>
              Precio:{{ ' ' }}
            </span>
            {{ course?.mount | currency }}
          </p>

          <p class="tag">
            <span class="tag-span">
              <i class="pi pi-tag" aria-hidden="true"></i>
              Etiqueta:{{ ' ' }}
            </span>
            {{ course.label }}
          </p>
        </div>

        <button (click)="view(course)" class="open-button">
          Ver curso
        </button>
      </div>
    </div>
  </div>
</app-layout>